const newsContent = {
  title: '뉴스 관리 매뉴얼',
  content: `
  <div class="page-title">[뉴스 관리]</div>

# [개요]
뉴스 관리는 기업의 뉴스와 보도자료를 효율적으로 관리하고 제공하기 위한 도구입니다. 이 문서에서는 **뉴스의 등록, 수정, 조회 등 전반적인 관리 방법**을 확인할 수 있습니다.

### 주요 기능 요약
| 기능 | 설명 | 권한 |
|------|------------------|------------|
| 뉴스 조회 | 등록된 뉴스 목록 확인 및 검색 | 관리자 |
| 뉴스 등록 | 신규 뉴스 등록 | 관리자 |
| 뉴스 수정 | 기존 뉴스 정보 수정 | 관리자 |

# [조회]
등록된 뉴스의 목록을 조회하고 관리할 수 있습니다.

### 📋 화면 구성 및 기능
| 영역 | 구성 | 주요 기능 |
|------|------|-----------|
| 검색 영역 | 검색 조건 및 필터 | • 카테고리별 필터링<br>• 검색어 기준 검색 |
| 목록 영역 | 뉴스 목록 테이블 | • 카테고리/제목 확인<br>• 더블클릭으로 상세 정보 확인 |
| 버튼 영역 | 등록 버튼 | • 신규 뉴스 등록 |

![뉴스 목록](/assets/images/guide/news/list.png)

# [등록/수정]
뉴스를 신규 등록하거나 기존 뉴스의 상세 정보를 수정할 수 있습니다.

> ⚠️ **주의사항**
> - 실제 등록일은 실제 뉴스가 발행된 날짜를 입력합니다.
> - 이미지는 여러 개 등록 가능합니다.
> - 저장 즉시 반영됩니다.

### 📋 화면 구성 및 기능
| 영역 | 입력 항목 | 설명 |
|------|-----------|------|
| 기본 정보 | • 뉴스 카테고리<br>• 출처<br>• 관련 링크<br>• 실제 등록일 | • 뉴스 카테고리 선택<br>• 뉴스 출처 입력<br>• 관련 웹페이지 URL 입력<br>• 실제 뉴스 발행일 설정 |
| 콘텐츠 | • 제목<br>• 내용<br>• 이미지 | • 뉴스 제목 입력<br>• 뉴스 상세 내용 입력<br>• 관련 이미지 업로드 |

![뉴스 등록/수정](/assets/images/guide/news/edit.png)
  `,
};

export default newsContent;
